/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import {
  isIFrame,
  getPortalHost,
  getMSALToken,
} from "@jda/lui-portal-utilities";

import { AuthService } from "../auth/authService";
import {
  LOCAL_STORAGE_LAST_CONNECTION,
  LOCAL_STORAGE_TIMEOUT_OPT_IN,
} from "../auth/constants";

export const createRequestObject = (requestUrl: string) => {
  const request: any = {
    url: requestUrl,
  };
  if (!isIFrame()) {
    request.tokenProvider = AuthService.getInstance().getAuthToken;
  }
  return request;
};

export const getValidationErrorMessages = (error: any) => {
  let errorMessage = error?.response?.data?.message || error?.message || "";
  if (error?.response?.data?.validationErrors?.length) {
    errorMessage = error.response.data.validationErrors[0].message;
  }
  return errorMessage;
};
export const getPortalToken = async (): Promise<any> => {
  if (isIFrame()) {
    return getMSALToken();
  } else {
    return getAuthToken();
  }
};
export const getAuthToken = async () => {
  const token = await AuthService.getInstance().getAuthToken();
  return token.accessToken;
};

export const removeTimeoutOtpFromStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_TIMEOUT_OPT_IN);
  localStorage.removeItem(LOCAL_STORAGE_LAST_CONNECTION);
};

export const isDevEnv = (): boolean => {
  const hostName = getPortalHost()
    .replace("https://", "")
    .replace("http://", "");
  const urlParts = hostName.split(".");
  if (urlParts.length === 6) {
    const [realm, service, runtime, geography, domainName, domain] = urlParts;
    return runtime === "dev";
  }
  return false;
};
